import React from 'react';
import NavigationVariant from './NavigationVariant';
import NavigationControl from './NavigationControl';

const Navigation = props => {
  const testVariation = process.env.GATSBY_NAVIGATION_TEST_VARIATION;

  return testVariation === 'variant' ? (
    <NavigationVariant {...props} />
  ) : (
    <NavigationControl {...props} />
  );
};

export default Navigation;
